/**
 * 任務追蹤 API helper
 */
import axios from 'axios';
import { getAdminToken } from '../components/AdminAuthGate';

const base = '/api/admin/track';
const VIEWER_KEY = 'track.viewerId';

export function getViewerId() {
  return localStorage.getItem(VIEWER_KEY) || '';
}

export function storeViewerId(v) {
  if (v) localStorage.setItem(VIEWER_KEY, String(v));
  else localStorage.removeItem(VIEWER_KEY);
}

function headers(extra = {}) {
  const h = { ...extra };
  const token = getAdminToken();
  if (token) h.Authorization = `Bearer ${token}`;
  const actor = getViewerId();
  if (actor) h['X-Track-Actor'] = actor;
  return h;
}

async function req(method, url, data, params) {
  const res = await axios({ method, url: `${base}${url}`, data, params, headers: headers() });
  return res.data;
}

export function errMsg(e) {
  return e?.response?.data?.error || e?.message || '操作失敗';
}

export const trackApi = {
  meta: () => req('get', '/meta'),
  lineTemplate: () => req('get', '/line-template'),

  createBoard: (b) => req('post', '/boards', b),
  patchBoard: (id, b) => req('patch', `/boards/${id}`, b),

  listFields: (boardId) => req('get', `/boards/${boardId}/fields`),
  createField: (boardId, b) => req('post', `/boards/${boardId}/fields`, b),
  patchField: (fid, b) => req('patch', `/fields/${fid}`, b),
  deleteField: (fid) => req('delete', `/fields/${fid}`),
  reorderFields: (boardId, ids) => req('post', `/boards/${boardId}/fields/reorder`, { ids }),

  listMembers: () => req('get', '/members'),
  createMember: (b) => req('post', '/members', b),
  patchMember: (id, b) => req('patch', `/members/${id}`, b),
  bindMember: (id, memberId) => req('post', `/members/${id}/bind`, { memberId }),
  reorderMembers: (ids) => req('post', '/members/reorder', { ids }),
  searchSiteMembers: (q) => req('get', '/member-search', undefined, { q }),

  listTasks: (params) => req('get', '/tasks', undefined, params),
  getTask: (id) => req('get', `/tasks/${id}`),
  createTask: (b) => req('post', '/tasks', b),
  patchTask: (id, b) => req('patch', `/tasks/${id}`, b),
  addNote: (id, note) => req('post', `/tasks/${id}/notes`, { note }),
  deleteTask: (id) => req('delete', `/tasks/${id}`),
  reorderTasks: (ids) => req('post', '/tasks/reorder', { ids }),

  uploadAttachments: async (taskId, files) => {
    const fd = new FormData();
    Array.from(files).forEach((f) => fd.append('files', f));
    const res = await axios.post(`${base}/tasks/${taskId}/attachments`, fd, { headers: headers() });
    return res.data;
  },
  deleteAttachment: (aid) => req('delete', `/attachments/${aid}`),

  dashboard: (params) => req('get', '/dashboard', undefined, params),
  gantt: (params) => req('get', '/gantt', undefined, params),

  notifyPreview: (boardId) => req('get', `/boards/${boardId}/notify/preview`),
  notifySendNow: (boardId) => req('post', `/boards/${boardId}/notify/send-now`),
  notifyLogs: (boardId) => req('get', `/boards/${boardId}/notify/logs`),

  listLineGroups: async () => {
    const res = await axios.get('/api/vb/admin/line-groups', { params: { activeOnly: 1 }, headers: headers() });
    return res.data;
  },
};
